import { NotesListLoading } from '@/_containers/notes';

export default function Loading() {
  return <NotesListLoading />;
}
